export default __webpack_public_path__ + "static/media/info_error.0a6a090e.svg";